import React, { FC, useContext, useEffect, useState } from 'react'
import { useReloader } from './use-reload'
import { graphApi } from '../api/subgraph/graph-client'
import {
  continuePoolProcess,
  initPoolProcess,
  PartialLine,
} from '../logic/pools/process-pools'
import { Web3Context } from './web3'
import { PoolApi } from '../api/web3/pool-api'
import { oracleApi } from '../api/oracle/oracle-client'

export interface PoolsState {
  //TODO: rename pools by lines
  pools: PartialLine[]
  loading: boolean
  userSharesLoaded: boolean
}

const initialState: PoolsState = {
  pools: [],
  loading: true,
  userSharesLoaded: false,
}
export const PoolsContext = React.createContext<PoolsState>(initialState)

export const PoolsProvider: FC = ({ children }) => {
  const [poolsState, setPoolsState] = useState<PoolsState>(initialState)
  const { connected, nonce } = useReloader()
  const web3Context = useContext(Web3Context)
  const { web3, account, whitelist, proxy, factoryContractAddress } =
    web3Context

  useEffect(() => {
    if (!nonce) {
      return
    }

    setPoolsState({
      pools: poolsState.pools,
      loading: true,
      userSharesLoaded: false,
    })
    graphApi
      .getPools()
      .then(pools => {
        const lines = initPoolProcess(pools)
        setPoolsState({
          pools: lines,
          loading: false,
          userSharesLoaded: false,
        })
        return lines
      })
      .then(quickLines => {
        if (
          quickLines &&
          web3Context.isConnectedToWeb3 &&
          web3Context.account
        ) {
          continuePoolProcess(quickLines, web3Context.account).then(
            fullLines => {
              setPoolsState({
                pools: fullLines,
                loading: false,
                userSharesLoaded: true,
              })
            }
          )
        }
      })
  }, [nonce])

  return (
    <PoolsContext.Provider value={poolsState}>{children}</PoolsContext.Provider>
  )
}

export const usePools = () => React.useContext(PoolsContext)
